


























































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

import CONFIG from "@/common/config";
import fetch from "@/common/api/fetch";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { pickHtmlTextContent } from '@/common/utils/dealWithString';
import { ShareObjectInterface, SignatureData, AxiosPromiseData } from "@/common/interface";

import ActivitySection from "@/components/common/index/ActivitySection.vue";
import GroupActivitySection from "@/components/groupType/index/GroupActivitySection.vue";

import SolitaireingListModal from "./SolitaireingListModal.vue";

@Component({
  components: {
    "group-activity-section": GroupActivitySection,
    "solitaireing-list-modal": SolitaireingListModal,
    "activity-section": ActivitySection,
  }
})
export default class SolitaireingList extends Vue {
  @Getter("title") title!: string;
  @Getter("section") section!: any;
  @Getter("titleSection") titleSection!: any;
  @Getter("hasPaidNumber") hasPaidNumber!: number;
  @Getter("joinNumber") joinNumber!: number;
  @Getter("canPay") canPay!: boolean;
  @Getter("gradientColor") gradientColor!: string;
  @Getter("urlUid") urlUid!: string;
  @Getter("coverTiny") coverTiny!: string;
  @Getter("signature") signature!: SignatureData;

  @Action("changeSolitaireingList") changeSolitaireingList!: Function;
  @Action("changeUrlUid") changeUrlUid!: Function;
  @Action("changeShowFooter") changeShowFooter!: Function;
  @Getter("solitaireingList") solitaireingList!: Array<object>;

  getUrlParam: Function = getUrlParam;
  showSolitaireingModal: boolean = false;
  totalCount: number = 0;

  mounted() {
    if (getUrlParam("type") === "share") {
      this.getSolitaireingList();
    }
  }
  getSolitaireingList() {
    const param = {
      activityId: getUrlParam("broadcastId"),
      pageNo: 0,
      pageSize: 16
    };
    fetch
      .newpost("anon/solitaire/getAllApplySignIns", param)
      .then((res: AxiosPromiseData) => {
        this.changeSolitaireingList(res.result.records);
        this.totalCount = res.totalCount;
      });
  }
 
  handleToggleMore(){
    this.showSolitaireingModal = !this.showSolitaireingModal;
  }
}
